import { render, staticRenderFns } from "./LgFinder.vue?vue&type=template&id=f33317aa&scoped=true"
import script from "./LgFinder.vue?vue&type=script&lang=js"
export * from "./LgFinder.vue?vue&type=script&lang=js"
import style0 from "./LgFinder.vue?vue&type=style&index=0&id=f33317aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33317aa",
  null
  
)

export default component.exports